import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Permission } from 'src/app/constants/permission.constant';
import { IOutputsCollection } from 'src/app/models/outputsCollection';
import { AuthService } from 'src/app/services/auth.service';
import { OutputsCollectionsService } from 'src/app/services/outputs-collections.service';

@Component({
  selector: 'app-release-outputs-collection-action',
  templateUrl: './release-outputs-collection-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ReleaseOutputsCollectionActionComponent {
  @Input() collection!: IOutputsCollection;
  @Output() actionComplete = new EventEmitter<void>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private outputsCollectionsService: OutputsCollectionsService,
    private snackBar: MatSnackBar,
  ) {}

  onToggleRelease(): void {
    if (!this.collection.id) return;

    const action$ = this.collection.releasedToClient
      ? this.outputsCollectionsService.unReleaseOutputsCollection(this.collection.id)
      : this.outputsCollectionsService.releaseOutputsCollection(this.collection.id);

    action$.subscribe({
      next: () => {
        const msg = this.collection.releasedToClient
          ? 'Unreleased from client'
          : 'Released to client';
        this.snackBar.open(msg, 'close', { duration: 2000 });
        this.actionComplete.emit();
      },
      error: () => {
        this.snackBar.open('Action failed', 'close', { duration: 2000 });
      },
    });
  }
}
